import { type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { RoomCard } from '@/features/jobs/details/components/RoomCard'
import type { RoomViewModel } from '@/features/messaging/rooms/RoomViewModel'

export interface RoomCardContainerProps {
  vm: RoomViewModel
  buttonGroup?: ReactNode
  titleContent?: ReactNode
  descriptionContent?: ReactNode
  progressBar?: ReactNode
}

export const RoomCardContainer = observer(function RoomCardContainer({
  vm,
  titleContent,
  descriptionContent,
  buttonGroup,
  progressBar,
}: RoomCardContainerProps) {
  return (
    <RoomCard
      isActive={vm.activeRoom}
      hasActiveParticipants={vm.room.activeParticipants.length > 0}
      participants={vm.participants.map((p) => ({
        publicId: p.user.publicId,
        displayName: p.user.displayName,
        avatar: p.user.avatar,
        avatarFallback: p.user.avatarFallback,
      }))}
      isJoinPending={vm.join.pending}
      isRoomClosed={vm.isRoomClosed}
      onJoin={vm.join}
      titleContent={titleContent}
      descriptionContent={descriptionContent}
      buttonGroup={buttonGroup}
      progressBar={progressBar}
      testId="current-task-new"
    />
  )
})
